export * from "-!../../../../node_modules/style-loader/index.js!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./side-menu.vue?vue&type=style&index=0&id=2a5ed71f&lang=scss"


//////////////////
// WEBPACK FOOTER
// ./src/js/components/side-menu/side-menu.vue?vue&type=style&index=0&id=2a5ed71f&lang=scss
// module id = ./src/js/components/side-menu/side-menu.vue?vue&type=style&index=0&id=2a5ed71f&lang=scss
// module chunks = 4